import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Item } from 'react-stately';
import {
  IconDevicePhoneOutline,
} from '@saucelabs/ds-icons';
import { Filter } from '@saucelabs/ds-filters';

import actions from '../../actions';
import constants from '../../constants';
import selectors from '../../selectors';
import { trackEvent, MANUAL_EVENTS } from '../../../../tracking';

const {
  MOBILE_SELECTION_FILTER_CATEGORY: FILTER_CATEGORY,
} = constants;

const ManufacturersFilter: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    activeFilters,
    currentFacets,
    testType,
  } = useSelector(selectors.mobileSelectionSelector);

  let facetsForActivePlatform = currentFacets?.ALL || {};

  // only show manufacturer options for the selected platform if one is selected
  const activePlatformFilterValues = activeFilters.get(FILTER_CATEGORY.OS);
  if (activePlatformFilterValues.size === 1) {
    facetsForActivePlatform = currentFacets?.[activePlatformFilterValues.first()] || {};
  }

  const availableManufacturers = facetsForActivePlatform?.[FILTER_CATEGORY.MANUFACTURER] || [];

  const activeManufacturerFilterValues = activeFilters.get(FILTER_CATEGORY.MANUFACTURER);

  return (
    <Filter
      data-qa="device-filter-bar-manufacturers"
      label="All Manufacturers"
      name="manufacturers"
      onSelectionChange={(newValues) => {
        dispatch(
          actions.setFilters({
            category: FILTER_CATEGORY.MANUFACTURER,
            values: [...newValues],
          }));
        trackEvent(MANUAL_EVENTS.FILTER_REAL_DEVICE, {
          filterCategory: FILTER_CATEGORY.MANUFACTURER,
          filterValues: [...newValues],
          testType,
        });
      }}
      prefixIcon={IconDevicePhoneOutline}
      selectedKeys={activeManufacturerFilterValues}
      selectionMode="multiple"
      type="listbox"
    >
      {availableManufacturers.map((manufacturer) => (
        <Item
          key={manufacturer}
          textValue={manufacturer}
        >
          {manufacturer}
        </Item>
      ))}
    </Filter>
  );
};

export default ManufacturersFilter;
